module.exports = __webpack_public_path__ + "static/media/exterior_front.8260995a.png";